import CourseUnitAttendanceTable from './CourseUnitAttendanceTable';

export default CourseUnitAttendanceTable;
